module.exports = __webpack_public_path__ + "img/V.1 290821 Temanbakat.id - Ilsutrasi 50.07042c85.png";